@file:OptIn(InternalResourceApi::class)

package dev.wyns.ventrova.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceContentHash
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String = "composeResources/dev.wyns.ventrova.resources/"

@delegate:ResourceContentHash(430_604_117)
internal val Res.string.action_back: StringResource by lazy {
      StringResource("string:action_back", "action_back", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 782, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 726, 27),
      ))
    }

@delegate:ResourceContentHash(-1_244_371_788)
internal val Res.string.action_call: StringResource by lazy {
      StringResource("string:action_call", "action_call", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 810, 23),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 754, 27),
      ))
    }

@delegate:ResourceContentHash(-1_335_498_755)
internal val Res.string.action_close: StringResource by lazy {
      StringResource("string:action_close", "action_close", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 834, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 782, 28),
      ))
    }

@delegate:ResourceContentHash(-32_719_008)
internal val Res.string.action_route: StringResource by lazy {
      StringResource("string:action_route", "action_route", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 909, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 857, 28),
      ))
    }

@delegate:ResourceContentHash(-1_464_608_512)
internal val Res.string.action_route_walk: StringResource by lazy {
      StringResource("string:action_route_walk", "action_route_walk", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 863, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 811, 45),
      ))
    }

@delegate:ResourceContentHash(-1_827_765_290)
internal val Res.string.action_save: StringResource by lazy {
      StringResource("string:action_save", "action_save", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 938, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 886, 27),
      ))
    }

@delegate:ResourceContentHash(1_520_528_677)
internal val Res.string.action_share: StringResource by lazy {
      StringResource("string:action_share", "action_share", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 966, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 914, 28),
      ))
    }

@delegate:ResourceContentHash(-411_363_552)
internal val Res.string.action_website: StringResource by lazy {
      StringResource("string:action_website", "action_website", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 995, 34),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 943, 34),
      ))
    }

@delegate:ResourceContentHash(358_888_672)
internal val Res.string.app_name: StringResource by lazy {
      StringResource("string:app_name", "app_name", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1030, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 978, 28),
      ))
    }

@delegate:ResourceContentHash(-1_050_810_629)
internal val Res.string.back_to_list: StringResource by lazy {
      StringResource("string:back_to_list", "back_to_list", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1059, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1007, 36),
      ))
    }

@delegate:ResourceContentHash(817_582_097)
internal val Res.string.category_bakery: StringResource by lazy {
      StringResource("string:category_bakery", "category_bakery", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1104, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1044, 31),
      ))
    }

@delegate:ResourceContentHash(471_750_432)
internal val Res.string.category_cafe: StringResource by lazy {
      StringResource("string:category_cafe", "category_cafe", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1140, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1076, 29),
      ))
    }

@delegate:ResourceContentHash(-88_911_680)
internal val Res.string.category_chip_shop: StringResource by lazy {
      StringResource("string:category_chip_shop", "category_chip_shop", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1170, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1106, 38),
      ))
    }

@delegate:ResourceContentHash(-2_146_816_054)
internal val Res.string.category_dessert: StringResource by lazy {
      StringResource("string:category_dessert", "category_dessert", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1209, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1145, 52),
      ))
    }

@delegate:ResourceContentHash(-139_322_061)
internal val Res.string.category_fast_food: StringResource by lazy {
      StringResource("string:category_fast_food", "category_fast_food", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1254, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1198, 38),
      ))
    }

@delegate:ResourceContentHash(1_013_819_584)
internal val Res.string.category_food_truck: StringResource by lazy {
      StringResource("string:category_food_truck", "category_food_truck", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1293, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1237, 43),
      ))
    }

@delegate:ResourceContentHash(-1_618_812_928)
internal val Res.string.category_restaurant: StringResource by lazy {
      StringResource("string:category_restaurant", "category_restaurant", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1333, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1281, 43),
      ))
    }

@delegate:ResourceContentHash(-1_039_184_810)
internal val Res.string.category_shop: StringResource by lazy {
      StringResource("string:category_shop", "category_shop", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1377, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1325, 29),
      ))
    }

@delegate:ResourceContentHash(-90_576_753)
internal val Res.string.day_friday: StringResource by lazy {
      StringResource("string:day_friday", "day_friday", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1436, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1384, 26),
      ))
    }

@delegate:ResourceContentHash(98_252_132)
internal val Res.string.day_friday_short: StringResource by lazy {
      StringResource("string:day_friday_short", "day_friday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1407, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1355, 28),
      ))
    }

@delegate:ResourceContentHash(-44_354_330)
internal val Res.string.day_monday: StringResource by lazy {
      StringResource("string:day_monday", "day_monday", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1496, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1440, 26),
      ))
    }

@delegate:ResourceContentHash(95_753_010)
internal val Res.string.day_monday_short: StringResource by lazy {
      StringResource("string:day_monday_short", "day_monday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1467, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1411, 28),
      ))
    }

@delegate:ResourceContentHash(1_128_994_340)
internal val Res.string.day_saturday: StringResource by lazy {
      StringResource("string:day_saturday", "day_saturday", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1558, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1498, 32),
      ))
    }

@delegate:ResourceContentHash(99_173_543)
internal val Res.string.day_saturday_short: StringResource by lazy {
      StringResource("string:day_saturday_short", "day_saturday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1527, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1467, 30),
      ))
    }

@delegate:ResourceContentHash(-287_512_000)
internal val Res.string.day_sunday: StringResource by lazy {
      StringResource("string:day_sunday", "day_sunday", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1620, 26),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1560, 26),
      ))
    }

@delegate:ResourceContentHash(99_162_576)
internal val Res.string.day_sunday_short: StringResource by lazy {
      StringResource("string:day_sunday_short", "day_sunday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1591, 28),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1531, 28),
      ))
    }

@delegate:ResourceContentHash(1_131_400_485)
internal val Res.string.day_thursday: StringResource by lazy {
      StringResource("string:day_thursday", "day_thursday", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1678, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1618, 32),
      ))
    }

@delegate:ResourceContentHash(87_921_288)
internal val Res.string.day_thursday_short: StringResource by lazy {
      StringResource("string:day_thursday_short", "day_thursday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1647, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1587, 30),
      ))
    }

@delegate:ResourceContentHash(-509_485_567)
internal val Res.string.day_tuesday: StringResource by lazy {
      StringResource("string:day_tuesday", "day_tuesday", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1741, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1681, 31),
      ))
    }

@delegate:ResourceContentHash(87_970_761)
internal val Res.string.day_tuesday_short: StringResource by lazy {
      StringResource("string:day_tuesday_short", "day_tuesday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1711, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1651, 29),
      ))
    }

@delegate:ResourceContentHash(-1_207_752_294)
internal val Res.string.day_wednesday: StringResource by lazy {
      StringResource("string:day_wednesday", "day_wednesday", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1805, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1745, 33),
      ))
    }

@delegate:ResourceContentHash(96_510_206)
internal val Res.string.day_wednesday_short: StringResource by lazy {
      StringResource("string:day_wednesday_short", "day_wednesday_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1773, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1713, 31),
      ))
    }

@delegate:ResourceContentHash(74_549_574)
internal val Res.string.decimal_separator: StringResource by lazy {
      StringResource("string:decimal_separator", "decimal_separator", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1839, 29),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1779, 29),
      ))
    }

@delegate:ResourceContentHash(1_588_353_280)
internal val Res.string.dish_tag_vegan: StringResource by lazy {
      StringResource("string:dish_tag_vegan", "dish_tag_vegan", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1977, 30),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1917, 30),
      ))
    }

@delegate:ResourceContentHash(-52_597_372)
internal val Res.string.dish_tag_vegan_likely: StringResource by lazy {
      StringResource("string:dish_tag_vegan_likely", "dish_tag_vegan_likely", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1869, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1809, 49),
      ))
    }

@delegate:ResourceContentHash(-895_948_628)
internal val Res.string.dish_tag_vegan_on_request: StringResource by lazy {
      StringResource("string:dish_tag_vegan_on_request", "dish_tag_vegan_on_request", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 1923, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1859, 57),
      ))
    }

@delegate:ResourceContentHash(2_067_760_548)
internal val Res.string.dish_tag_vegetarian: StringResource by lazy {
      StringResource("string:dish_tag_vegetarian", "dish_tag_vegetarian", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2075, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2011, 43),
      ))
    }

@delegate:ResourceContentHash(-1_034_870_724)
internal val Res.string.dish_tag_vegetarian_likely: StringResource by lazy {
      StringResource("string:dish_tag_vegetarian_likely", "dish_tag_vegetarian_likely", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2008, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1948, 62),
      ))
    }

@delegate:ResourceContentHash(412_680_352)
internal val Res.string.distance_kilometers: StringResource by lazy {
      StringResource("string:distance_kilometers", "distance_kilometers", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2119, 39),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2055, 39),
      ))
    }

@delegate:ResourceContentHash(-841_900_704)
internal val Res.string.distance_meters: StringResource by lazy {
      StringResource("string:distance_meters", "distance_meters", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2159, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2095, 31),
      ))
    }

@delegate:ResourceContentHash(970_987_223)
internal val Res.string.favorite_removed: StringResource by lazy {
      StringResource("string:favorite_removed", "favorite_removed", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2191, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2127, 56),
      ))
    }

@delegate:ResourceContentHash(501_420_113)
internal val Res.string.favorite_saved: StringResource by lazy {
      StringResource("string:favorite_saved", "favorite_saved", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2252, 50),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2184, 46),
      ))
    }

@delegate:ResourceContentHash(1_193_166_890)
internal val Res.string.favorites: StringResource by lazy {
      StringResource("string:favorites", "favorites", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2513, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2417, 29),
      ))
    }

@delegate:ResourceContentHash(-1_203_059_438)
internal val Res.string.favorites_empty: StringResource by lazy {
      StringResource("string:favorites_empty", "favorites_empty", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2371, 95),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2291, 79),
      ))
    }

@delegate:ResourceContentHash(2_071_747_590)
internal val Res.string.favorites_empty_web: StringResource by lazy {
      StringResource("string:favorites_empty_web", "favorites_empty_web", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2303, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2231, 59),
      ))
    }

@delegate:ResourceContentHash(67_742_348)
internal val Res.string.favorites_tab: StringResource by lazy {
      StringResource("string:favorites_tab", "favorites_tab", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2467, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2371, 45),
      ))
    }

@delegate:ResourceContentHash(-1_949_623_788)
internal val Res.string.filter_all_levels: StringResource by lazy {
      StringResource("string:filter_all_levels", "filter_all_levels", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2547, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2447, 41),
      ))
    }

@delegate:ResourceContentHash(183_256_766)
internal val Res.string.filter_clear: StringResource by lazy {
      StringResource("string:filter_clear", "filter_clear", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2671, 24),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2575, 28),
      ))
    }

@delegate:ResourceContentHash(-1_780_410_835)
internal val Res.string.filter_clear_all: StringResource by lazy {
      StringResource("string:filter_clear_all", "filter_clear_all", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2589, 36),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2489, 36),
      ))
    }

@delegate:ResourceContentHash(-1_479_972_787)
internal val Res.string.filter_clear_filters: StringResource by lazy {
      StringResource("string:filter_clear_filters", "filter_clear_filters", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2626, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2526, 48),
      ))
    }

@delegate:ResourceContentHash(232_920_983)
internal val Res.string.filter_distance: StringResource by lazy {
      StringResource("string:filter_distance", "filter_distance", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2785, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2689, 35),
      ))
    }

@delegate:ResourceContentHash(-862_320_366)
internal val Res.string.filter_distance_all: StringResource by lazy {
      StringResource("string:filter_distance_all", "filter_distance_all", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2749, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2657, 31),
      ))
    }

@delegate:ResourceContentHash(631_859_888)
internal val Res.string.filter_distance_all_long: StringResource by lazy {
      StringResource("string:filter_distance_all_long", "filter_distance_all_long", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2696, 52),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2604, 52),
      ))
    }

@delegate:ResourceContentHash(1_216_483_348)
internal val Res.string.filter_how_plant_based: StringResource by lazy {
      StringResource("string:filter_how_plant_based", "filter_how_plant_based", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2821, 54),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2725, 54),
      ))
    }

@delegate:ResourceContentHash(1_970_502_222)
internal val Res.string.filter_kind_of_place: StringResource by lazy {
      StringResource("string:filter_kind_of_place", "filter_kind_of_place", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2876, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2780, 48),
      ))
    }

@delegate:ResourceContentHash(-979_358_366)
internal val Res.string.filter_open_now: StringResource by lazy {
      StringResource("string:filter_open_now", "filter_open_now", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2989, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2889, 35),
      ))
    }

@delegate:ResourceContentHash(-1_593_012_578)
internal val Res.string.filter_open_now_description: StringResource by lazy {
      StringResource("string:filter_open_now_description", "filter_open_now_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 2921, 67),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2829, 59),
      ))
    }

@delegate:ResourceContentHash(-897_970_068)
internal val Res.string.filter_stop_custom: StringResource by lazy {
      StringResource("string:filter_stop_custom", "filter_stop_custom", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3025, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2925, 50),
      ))
    }

@delegate:ResourceContentHash(-475_309_524)
internal val Res.string.filter_stop_options: StringResource by lazy {
      StringResource("string:filter_stop_options", "filter_stop_options", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3144, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3056, 47),
      ))
    }

@delegate:ResourceContentHash(-564_781_916)
internal val Res.string.filter_stop_options_description: StringResource by lazy {
      StringResource("string:filter_stop_options_description", "filter_stop_options_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3072, 71),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 2976, 79),
      ))
    }

@delegate:ResourceContentHash(-1_695_370_368)
internal val Res.string.filter_stop_vegan: StringResource by lazy {
      StringResource("string:filter_stop_vegan", "filter_stop_vegan", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3250, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3162, 41),
      ))
    }

@delegate:ResourceContentHash(2_000_744_464)
internal val Res.string.filter_stop_vegan_description: StringResource by lazy {
      StringResource("string:filter_stop_vegan_description", "filter_stop_vegan_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3188, 61),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3104, 57),
      ))
    }

@delegate:ResourceContentHash(-1_801_723_680)
internal val Res.string.filter_stop_vegetarian: StringResource by lazy {
      StringResource("string:filter_stop_vegetarian", "filter_stop_vegetarian", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3363, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3275, 38),
      ))
    }

@delegate:ResourceContentHash(1_157_683_074)
internal val Res.string.filter_stop_vegetarian_description: StringResource by lazy {
      StringResource("string:filter_stop_vegetarian_description", "filter_stop_vegetarian_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3292, 70),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3204, 70),
      ))
    }

@delegate:ResourceContentHash(1_274_304_640)
internal val Res.string.filter_up_to: StringResource by lazy {
      StringResource("string:filter_up_to", "filter_up_to", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3402, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3314, 32),
      ))
    }

@delegate:ResourceContentHash(-316_065_920)
internal val Res.string.filters: StringResource by lazy {
      StringResource("string:filters", "filters", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3435, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3347, 27),
      ))
    }

@delegate:ResourceContentHash(-1_087_691_359)
internal val Res.string.fry_oil_animal_description: StringResource by lazy {
      StringResource("string:fry_oil_animal_description", "fry_oil_animal_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3463, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3375, 98),
      ))
    }

@delegate:ResourceContentHash(1_870_396_658)
internal val Res.string.fry_oil_animal_label: StringResource by lazy {
      StringResource("string:fry_oil_animal_label", "fry_oil_animal_label", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3566, 68),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3474, 72),
      ))
    }

@delegate:ResourceContentHash(-1_973_104_494)
internal val Res.string.fry_oil_animal_short: StringResource by lazy {
      StringResource("string:fry_oil_animal_short", "fry_oil_animal_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3635, 44),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3547, 44),
      ))
    }

@delegate:ResourceContentHash(85_333_262)
internal val Res.string.fry_oil_plant_description: StringResource by lazy {
      StringResource("string:fry_oil_plant_description", "fry_oil_plant_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3680, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3592, 93),
      ))
    }

@delegate:ResourceContentHash(-1_677_377_452)
internal val Res.string.fry_oil_plant_label: StringResource by lazy {
      StringResource("string:fry_oil_plant_label", "fry_oil_plant_label", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3778, 59),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3686, 59),
      ))
    }

@delegate:ResourceContentHash(-965_694_845)
internal val Res.string.fry_oil_plant_short: StringResource by lazy {
      StringResource("string:fry_oil_plant_short", "fry_oil_plant_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3838, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3746, 39),
      ))
    }

@delegate:ResourceContentHash(-1_090_251_648)
internal val Res.string.fry_oil_report: StringResource by lazy {
      StringResource("string:fry_oil_report", "fry_oil_report", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3971, 66),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3863, 54),
      ))
    }

@delegate:ResourceContentHash(873_945_251)
internal val Res.string.fry_oil_reported: StringResource by lazy {
      StringResource("string:fry_oil_reported", "fry_oil_reported", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 3890, 80),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3786, 76),
      ))
    }

@delegate:ResourceContentHash(-655_389_723)
internal val Res.string.fry_oil_unknown_description: StringResource by lazy {
      StringResource("string:fry_oil_unknown_description", "fry_oil_unknown_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4038, 155),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 3918, 139),
      ))
    }

@delegate:ResourceContentHash(1_021_752_977)
internal val Res.string.fry_oil_unknown_label: StringResource by lazy {
      StringResource("string:fry_oil_unknown_label", "fry_oil_unknown_label", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4194, 73),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4058, 73),
      ))
    }

@delegate:ResourceContentHash(1_000_565_669)
internal val Res.string.fry_oil_unknown_short: StringResource by lazy {
      StringResource("string:fry_oil_unknown_short", "fry_oil_unknown_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4268, 49),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4132, 45),
      ))
    }

@delegate:ResourceContentHash(-578_787_633)
internal val Res.string.level_options_description: StringResource by lazy {
      StringResource("string:level_options_description", "level_options_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4318, 97),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4178, 93),
      ))
    }

@delegate:ResourceContentHash(-475_309_524)
internal val Res.string.level_options_label: StringResource by lazy {
      StringResource("string:level_options_label", "level_options_label", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4416, 43),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4272, 47),
      ))
    }

@delegate:ResourceContentHash(153_470_188)
internal val Res.string.level_options_short: StringResource by lazy {
      StringResource("string:level_options_short", "level_options_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4460, 35),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4320, 39),
      ))
    }

@delegate:ResourceContentHash(99_486_336)
internal val Res.string.level_options_summary: StringResource by lazy {
      StringResource("string:level_options_summary", "level_options_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4496, 81),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4360, 77),
      ))
    }

@delegate:ResourceContentHash(-438_469_113)
internal val Res.string.level_vegan_description: StringResource by lazy {
      StringResource("string:level_vegan_description", "level_vegan_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4578, 75),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4438, 83),
      ))
    }

@delegate:ResourceContentHash(-1_695_370_368)
internal val Res.string.level_vegan_label: StringResource by lazy {
      StringResource("string:level_vegan_label", "level_vegan_label", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4654, 41),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4522, 41),
      ))
    }

@delegate:ResourceContentHash(-1_801_596_224)
internal val Res.string.level_vegan_short: StringResource by lazy {
      StringResource("string:level_vegan_short", "level_vegan_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4696, 33),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4564, 33),
      ))
    }

@delegate:ResourceContentHash(92_226_168)
internal val Res.string.level_vegan_summary: StringResource by lazy {
      StringResource("string:level_vegan_summary", "level_vegan_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4730, 51),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4598, 47),
      ))
    }

@delegate:ResourceContentHash(-675_071_102)
internal val Res.string.level_vegetarian_description: StringResource by lazy {
      StringResource("string:level_vegetarian_description", "level_vegetarian_description", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4782, 76),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4646, 76),
      ))
    }

@delegate:ResourceContentHash(-1_141_162_140)
internal val Res.string.level_vegetarian_label: StringResource by lazy {
      StringResource("string:level_vegetarian_label", "level_vegetarian_label", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4859, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4723, 46),
      ))
    }

@delegate:ResourceContentHash(-1_801_723_680)
internal val Res.string.level_vegetarian_short: StringResource by lazy {
      StringResource("string:level_vegetarian_short", "level_vegetarian_short", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4906, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4770, 38),
      ))
    }

@delegate:ResourceContentHash(410_272_429)
internal val Res.string.level_vegetarian_summary: StringResource by lazy {
      StringResource("string:level_vegetarian_summary", "level_vegetarian_summary", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 4945, 56),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4809, 52),
      ))
    }

@delegate:ResourceContentHash(-1_751_680_281)
internal val Res.string.loading: StringResource by lazy {
      StringResource("string:loading", "loading", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5002, 27),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4862, 31),
      ))
    }

@delegate:ResourceContentHash(-111_164_499)
internal val Res.string.location_off: StringResource by lazy {
      StringResource("string:location_off", "location_off", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5030, 60),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4894, 60),
      ))
    }

@delegate:ResourceContentHash(-1_787_990_912)
internal val Res.string.map_attribution: StringResource by lazy {
      StringResource("string:map_attribution", "map_attribution", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5091, 87),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 4955, 87),
      ))
    }

@delegate:ResourceContentHash(1_814_366_510)
internal val Res.string.map_locate: StringResource by lazy {
      StringResource("string:map_locate", "map_locate", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5179, 42),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5043, 42),
      ))
    }

@delegate:ResourceContentHash(245_934_816)
internal val Res.string.map_zoom_in: StringResource by lazy {
      StringResource("string:map_zoom_in", "map_zoom_in", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5222, 31),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5086, 31),
      ))
    }

@delegate:ResourceContentHash(-1_553_465_950)
internal val Res.string.map_zoom_out: StringResource by lazy {
      StringResource("string:map_zoom_out", "map_zoom_out", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5254, 32),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5118, 32),
      ))
    }

@delegate:ResourceContentHash(-1_287_084_740)
internal val Res.string.menu_inferred_notice: StringResource by lazy {
      StringResource("string:menu_inferred_notice", "menu_inferred_notice", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5287, 268),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5151, 272),
      ))
    }

@delegate:ResourceContentHash(-942_735_868)
internal val Res.string.menu_show_all: StringResource by lazy {
      StringResource("string:menu_show_all", "menu_show_all", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5556, 53),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5424, 49),
      ))
    }

@delegate:ResourceContentHash(-2_095_388_304)
internal val Res.string.menu_show_less: StringResource by lazy {
      StringResource("string:menu_show_less", "menu_show_less", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5610, 38),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5474, 38),
      ))
    }

@delegate:ResourceContentHash(1_596_697_141)
internal val Res.string.menu_source: StringResource by lazy {
      StringResource("string:menu_source", "menu_source", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5649, 107),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5513, 95),
      ))
    }

@delegate:ResourceContentHash(74_991_682)
internal val Res.string.menu_title: StringResource by lazy {
      StringResource("string:menu_title", "menu_title", setOf(
        ResourceItem(setOf(LanguageQualifier("nl"), ), "${MD}values-nl/strings.commonMain.cvr", 5798, 46),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 5654, 54),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("action_back", Res.string.action_back)
  map.put("action_call", Res.string.action_call)
  map.put("action_close", Res.string.action_close)
  map.put("action_route", Res.string.action_route)
  map.put("action_route_walk", Res.string.action_route_walk)
  map.put("action_save", Res.string.action_save)
  map.put("action_share", Res.string.action_share)
  map.put("action_website", Res.string.action_website)
  map.put("app_name", Res.string.app_name)
  map.put("back_to_list", Res.string.back_to_list)
  map.put("category_bakery", Res.string.category_bakery)
  map.put("category_cafe", Res.string.category_cafe)
  map.put("category_chip_shop", Res.string.category_chip_shop)
  map.put("category_dessert", Res.string.category_dessert)
  map.put("category_fast_food", Res.string.category_fast_food)
  map.put("category_food_truck", Res.string.category_food_truck)
  map.put("category_restaurant", Res.string.category_restaurant)
  map.put("category_shop", Res.string.category_shop)
  map.put("day_friday", Res.string.day_friday)
  map.put("day_friday_short", Res.string.day_friday_short)
  map.put("day_monday", Res.string.day_monday)
  map.put("day_monday_short", Res.string.day_monday_short)
  map.put("day_saturday", Res.string.day_saturday)
  map.put("day_saturday_short", Res.string.day_saturday_short)
  map.put("day_sunday", Res.string.day_sunday)
  map.put("day_sunday_short", Res.string.day_sunday_short)
  map.put("day_thursday", Res.string.day_thursday)
  map.put("day_thursday_short", Res.string.day_thursday_short)
  map.put("day_tuesday", Res.string.day_tuesday)
  map.put("day_tuesday_short", Res.string.day_tuesday_short)
  map.put("day_wednesday", Res.string.day_wednesday)
  map.put("day_wednesday_short", Res.string.day_wednesday_short)
  map.put("decimal_separator", Res.string.decimal_separator)
  map.put("dish_tag_vegan", Res.string.dish_tag_vegan)
  map.put("dish_tag_vegan_likely", Res.string.dish_tag_vegan_likely)
  map.put("dish_tag_vegan_on_request", Res.string.dish_tag_vegan_on_request)
  map.put("dish_tag_vegetarian", Res.string.dish_tag_vegetarian)
  map.put("dish_tag_vegetarian_likely", Res.string.dish_tag_vegetarian_likely)
  map.put("distance_kilometers", Res.string.distance_kilometers)
  map.put("distance_meters", Res.string.distance_meters)
  map.put("favorite_removed", Res.string.favorite_removed)
  map.put("favorite_saved", Res.string.favorite_saved)
  map.put("favorites", Res.string.favorites)
  map.put("favorites_empty", Res.string.favorites_empty)
  map.put("favorites_empty_web", Res.string.favorites_empty_web)
  map.put("favorites_tab", Res.string.favorites_tab)
  map.put("filter_all_levels", Res.string.filter_all_levels)
  map.put("filter_clear", Res.string.filter_clear)
  map.put("filter_clear_all", Res.string.filter_clear_all)
  map.put("filter_clear_filters", Res.string.filter_clear_filters)
  map.put("filter_distance", Res.string.filter_distance)
  map.put("filter_distance_all", Res.string.filter_distance_all)
  map.put("filter_distance_all_long", Res.string.filter_distance_all_long)
  map.put("filter_how_plant_based", Res.string.filter_how_plant_based)
  map.put("filter_kind_of_place", Res.string.filter_kind_of_place)
  map.put("filter_open_now", Res.string.filter_open_now)
  map.put("filter_open_now_description", Res.string.filter_open_now_description)
  map.put("filter_stop_custom", Res.string.filter_stop_custom)
  map.put("filter_stop_options", Res.string.filter_stop_options)
  map.put("filter_stop_options_description", Res.string.filter_stop_options_description)
  map.put("filter_stop_vegan", Res.string.filter_stop_vegan)
  map.put("filter_stop_vegan_description", Res.string.filter_stop_vegan_description)
  map.put("filter_stop_vegetarian", Res.string.filter_stop_vegetarian)
  map.put("filter_stop_vegetarian_description", Res.string.filter_stop_vegetarian_description)
  map.put("filter_up_to", Res.string.filter_up_to)
  map.put("filters", Res.string.filters)
  map.put("fry_oil_animal_description", Res.string.fry_oil_animal_description)
  map.put("fry_oil_animal_label", Res.string.fry_oil_animal_label)
  map.put("fry_oil_animal_short", Res.string.fry_oil_animal_short)
  map.put("fry_oil_plant_description", Res.string.fry_oil_plant_description)
  map.put("fry_oil_plant_label", Res.string.fry_oil_plant_label)
  map.put("fry_oil_plant_short", Res.string.fry_oil_plant_short)
  map.put("fry_oil_report", Res.string.fry_oil_report)
  map.put("fry_oil_reported", Res.string.fry_oil_reported)
  map.put("fry_oil_unknown_description", Res.string.fry_oil_unknown_description)
  map.put("fry_oil_unknown_label", Res.string.fry_oil_unknown_label)
  map.put("fry_oil_unknown_short", Res.string.fry_oil_unknown_short)
  map.put("level_options_description", Res.string.level_options_description)
  map.put("level_options_label", Res.string.level_options_label)
  map.put("level_options_short", Res.string.level_options_short)
  map.put("level_options_summary", Res.string.level_options_summary)
  map.put("level_vegan_description", Res.string.level_vegan_description)
  map.put("level_vegan_label", Res.string.level_vegan_label)
  map.put("level_vegan_short", Res.string.level_vegan_short)
  map.put("level_vegan_summary", Res.string.level_vegan_summary)
  map.put("level_vegetarian_description", Res.string.level_vegetarian_description)
  map.put("level_vegetarian_label", Res.string.level_vegetarian_label)
  map.put("level_vegetarian_short", Res.string.level_vegetarian_short)
  map.put("level_vegetarian_summary", Res.string.level_vegetarian_summary)
  map.put("loading", Res.string.loading)
  map.put("location_off", Res.string.location_off)
  map.put("map_attribution", Res.string.map_attribution)
  map.put("map_locate", Res.string.map_locate)
  map.put("map_zoom_in", Res.string.map_zoom_in)
  map.put("map_zoom_out", Res.string.map_zoom_out)
  map.put("menu_inferred_notice", Res.string.menu_inferred_notice)
  map.put("menu_show_all", Res.string.menu_show_all)
  map.put("menu_show_less", Res.string.menu_show_less)
  map.put("menu_source", Res.string.menu_source)
  map.put("menu_title", Res.string.menu_title)
}
